export default class EntityPageType {}

EntityPageType.Condition = 'condition';
EntityPageType.Symptom = 'symptom';
